import React from "react";

const Ordergrocerymenucontents = ({items=[]}) => {
    
    return(
        <>
            <div className="menu-items container-fluid ">
                <div className="row">
                    <div className="col-12 mx-auto">
                        <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-2 g-lg-3 my-5">
                            {
                                items.map((elem,index) => {
                                    const {id, product, image, count, points, category} = elem;
                                    return(
                                        <>
                                            <div class="col"  key={id}>
                                                <div class="p-3 border card-data text-center">
                                                    <figure>
                                                        <img src={image} alt="menu" className="img-thumbnail" />
                                                    </figure>
                                                    <h1 className="product-details product-name" title={product}>{product}</h1>
                                                    <p className="product-details product-count" title={count}>{count} Count</p>
                                                    <p className="product-details product-points" title={points}>{points} <i class="fas fa-rupee-sign"></i></p>
                                                    <button type="button" class="btn btn-primary cart-btn" title="Add to Cart"><i class="fas fa-shopping-cart"></i> Add to Cart</button>
                                                </div>
                                            </div>
                                            {/* <div className="card" key={id}>
                                                <img src={image} alt="menu" className="img-fluid" />
                                                <h1>{product}</h1>
                                                <p>{count}</p>
                                                <p>{points}</p>
                                            </div> */}
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>   

        </>
    )
}

export default Ordergrocerymenucontents;